const LightPlane = ({position, size, rotation, intensity, color}) => {

  return (
    <>
      <rectAreaLight
        color={"#fff"}
        intensity={intensity}
        width={size[0]}
        height={size[1]}
        position={position}
        rotation={rotation} // Повертає площину, щоб світло падало вниз
        castShadow={false}
      />
      {
        /*

      <mesh
        position={position}
        rotation={[(Math.PI / 2), 0, 0]} // Повертає площину, щоб відповідала `rectAreaLight`
      >
        <planeGeometry args={size} />
        <meshStandardMaterial color="red" />
      </mesh>
         */
      }
    </>
  )
}

export {
  LightPlane
}